/**
 * To format a given value to a currency format. By default,
 * we use 0 decimal places. If the symbol is not passed as a
 * parameter, then the formatted value doesn't include this.
 * The decimal part means that at most the first X decimal
 * places will be displayed. The symbol would be one of:
 *    - $, US$, €, UF, UTM
 * The symbol and decimal places normally can be obtained from the DB.
 */
export const formatOtherCurrency = (currency, decimals = 0, thousandsSep = '.', decimalSep = ',') => {
  const [integer, fraction] = currency.toString().split('.')
  const updatedCurrency = integer.replace(/(\d)(?=(?:[0-9,]{3})+\b)/g, `$1${thousandsSep}`)

  if ((!fraction && fraction !== 0) || decimals === 0) {
    return updatedCurrency
  }

  return `${updatedCurrency}${decimalSep}${fraction.substring(0, decimals)}`
}
/**
 * Rounds a number using the half-up method (rounds away from zero on .5)
 * to a specified number of decimal places.
 *
 * This implementation mitigates floating-point precision issues by using
 * `.toFixed(10)` before applying `Math.round`. For example:
 *  - 335.8592 with 2 decimals → 335.86
 *  - 398.0804 with 2 decimals → 398.08
 *
 * @function roundHalfUp
 * @param {number} value - The numeric value to round.
 * @param {number} decs - The number of decimal places to keep (>= 0).
 * @returns {number} The rounded number with the given precision.
 *
 * @example
 * roundHalfUp(335.8592, 2); // 335.86
 * roundHalfUp(398.0804, 2); // 398.08
 * roundHalfUp(25.6626 * 0.19, 4); // 4.8759
 */
export const roundHalfUp = (value, decs) => {
  const pow = Math.pow(10, decs)
  const scaled = Number((value * pow).toFixed(10))

  return Math.round(scaled) / pow
}
